import {connect} from 'react-redux';

import Menu from '../Menu.jsx';

function select(state, props) {
    const sports = state.application.getIn(['live', 'sports']);
    const displayMode = state.application.get('displayMode');

    return {
        ...props,
        sports,
        displayMode,
        user: state.auth.get('user'),
        countryCode: state.application.get('countryCode')
    };
}

export default connect(select)(Menu);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/Menu.jsx